module.exports = __webpack_public_path__ + "static/assets/e997e36ade408c75ef4424b928e10846.svg";